function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPay2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10 4)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 7.08 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(51,98,171)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-17.08, -4)",
    d: "M 18.655 1.01751 L 17.3977 1.01751 C 17.0175 1.01751 16.7251 1.13447 16.5497 1.51459 L 14.152 6.98242 L 15.848 6.98242 C 15.848 6.98242 16.1404 6.25143 16.1988 6.07599 C 16.3743 6.07599 18.0409 6.07599 18.2749 6.07599 C 18.3333 6.28067 18.4795 6.95318 18.4795 6.95318 L 20 6.95318 L 18.655 1.01751 Z M 16.6667 4.84792 C 16.8129 4.49704 17.3099 3.18125 17.3099 3.18125 C 17.3099 3.21049 17.4561 2.83038 17.5146 2.6257 L 17.6316 3.15201 C 17.6316 3.15201 17.9532 4.58476 18.0117 4.87716 L 16.6667 4.87716 L 16.6667 4.84792 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.05 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(51,98,171)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-12.05, -4)",
    d: "M 14.269 5.02338 C 14.269 6.25145 13.1579 7.07016 11.4327 7.07016 C 10.7018 7.07016 10 6.92396 9.61988 6.74852 L 9.8538 5.40349 L 10.0585 5.49121 C 10.5848 5.72513 10.9357 5.81285 11.5789 5.81285 C 12.0468 5.81285 12.5439 5.63741 12.5439 5.22806 C 12.5439 4.9649 12.3392 4.78946 11.6959 4.49706 C 11.0819 4.20466 10.2632 3.73683 10.2632 2.88887 C 10.2632 1.71928 11.4035 0.92981 13.0117 0.92981 C 13.6257 0.92981 14.152 1.04677 14.4737 1.19297 L 14.2398 2.47952 L 14.1228 2.36256 C 13.8304 2.2456 13.4503 2.12864 12.8947 2.12864 C 12.2807 2.15788 11.9883 2.42104 11.9883 2.65496 C 11.9883 2.91811 12.3392 3.12279 12.8947 3.38595 C 13.8304 3.82455 14.269 4.32162 14.269 5.02338 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.1 -1.48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(249,181,11)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1.9, -2.52)",
    d: "M 0 1.07603 L 0.0292398 0.959068 L 2.54386 0.959068 C 2.89474 0.959068 3.15789 1.07603 3.24561 1.45614 L 3.80117 4.08772 C 3.24561 2.68421 1.95906 1.54386 0 1.07603 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5.53 -0.03)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(51,98,171)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-4.47, -3.97)",
    d: "M 7.33918 1.01753 L 4.79532 6.9532 L 3.07017 6.9532 L 1.60819 1.98244 C 2.66082 2.65496 3.53801 3.70759 3.85965 4.43858 L 4.03509 5.05262 L 5.61403 0.988289 L 7.33918 0.988289 L 7.33918 1.01753 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.7 -0.03)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(51,98,171)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-8.3, -3.97)",
    d: "M 8.0117 0.988289 L 9.61989 0.988289 L 8.59649 6.9532 L 6.98831 6.9532 L 8.0117 0.988289 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay2);
export default __webpack_public_path__ + "static/media/Pay2.34ac1dedd95ab59fafe3e4a2d2fe60cb.svg";
export { ForwardRef as ReactComponent };